<template>
  <div class="edges-container">

    <div class="edges-list" v-if="edges && edges.length > 0">
      <div v-for="(edge, index) in edges" :key="index" class="edge-item"
        :class="{ 'is-default': selectedEdgeId === edge.id }">
        <div class="edge-number">{{ index + 1 }}</div>

        <div class="edge-default">
          <input :id="'e_' + index" class="radio-input" type="radio" @change="change(index)" :value="edge.id"
            v-model="selectedEdgeId">
          <label :for="'e_' + index" class="radio-label" v-b-tooltip.hover.top="'Встановити як основний'"></label>
        </div>

        <div class="edge-content">
          <div class="edge-name" :style="getEdgeStyle(edge)" :title="edge.full_name">
            {{ edge.full_name }}
          </div>
        </div>

        <div class="edge-actions">
          <div class="color-picker-container">
            <div class="color-box" :style="{ backgroundColor: edge.color }" @click="togglePicker(edge)"
              v-b-tooltip.hover.top="'Змінити колір'">
              <div v-if="colorsLoading" class="loading-spinner"></div>
            </div>
            <div v-if="edge.color_show" @click.stop class="popover">
              <sketch-picker :palette="availableColors" v-model="edge.color" @input="updateColor(edge, $event)" />
            </div>
          </div>
          <button class="btn btn-sm btn-outline-primary" @click="replace(index)" v-b-tooltip.hover.top="'Замінити'">
            <i class="fa fa-exchange-alt"></i>
          </button>
          <button class="btn btn-sm btn-outline-danger" @click="remove(index)" v-b-tooltip.hover.top="'Видалити'">
            <i class="far fa-trash-alt"></i>
          </button>

        </div>
      </div>
    </div>
    <div class="materials-empty">
      <div class="add-material-button" data-toggle="modal" data-target="#searchModal" @click="search('edges')">
        <div class="add-button-content">
          <i class="fas fa-plus"></i>
          <span>Додати кромку</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Compact } from 'vue-color'; // Импортируем Sketch Picker
import { mapGetters } from 'vuex';
import $ from 'jquery';

export default {
  name: "EdgeTable",
  props: [
    'toSearch',
    'edges',
    'edgeDefault',
  ],
  components: {
    'sketch-picker': Compact
  },
  computed: {
    ...mapGetters('data', ['edgeColors', 'colorsLoading']),
    selectedEdgeId: {
      get() {
        return this.edgeDefault ? this.edgeDefault.id : null;
      },
      set(value) {
        const edge = this.edges.find(e => e.id === value);
        if (edge) {
          this.$root.$emit('setEdgeDefault', edge);
        }
      }
    },
    availableColors() {
      // Если цвета еще не загрузились, используем дефолтные
      return this.edgeColors && this.edgeColors.length > 0
        ? this.edgeColors
        : ['#FF0000', '#FF7F00', '#00FF00', '#00FFFF', '#0000FF', '#8B00FF', '#A52A2A', '#FFC0CB', '#808080', '#000000', '#008080', '#FFD700', '#4B0082', '#006400', '#FF1493', '#00CED1', '#7FFF00', '#DA70D6', '#FF4500'];
    }
  },
  methods: {
    // Метод для получения стилей кромки
    getEdgeStyle(edge) {
      if (!edge.color) {
        return {
          color: '#000000',
          'border-bottom': '5px solid #dee2e6'
        };
      }

      return {
        color: '#000000',
        'border-bottom': `5px solid ${edge.color}`,
      };
    },
    togglePicker(model) {
      this.edges.forEach(model => model.color_show = false);
      model.color_show = !model.color_show; // Открытие/закрытие палитры
    },
    updateColor(model, newColor) {
      model.color = newColor.hex
    },
    closePicker(event) {
      if (!event.target.closest('.color-picker-container')) {
        this.edges.forEach(model => model.color_show = false);
      }
    },
    change(i) {
      if (this.edges[i]) {
        this.selectedEdgeId = this.edges[i].id;
      }
    },
    search(v) {
      // Сбрасываем замену при открытии модального окна для добавления
      this.$store.commit('data/SET_REPLACE', null);
      this.$emit('interface', v);
      this.toSearch = v;
    },
    remove(i) {
      this.$root.$emit('on-remove', 'edges', i);
    },
    replace(i) {
      this.$store.commit('data/SET_REPLACE', this.edges[i].ref);
      // this.search('edges');
      this.$nextTick(() => {
        $('#searchModal').modal('show');
      });
    }
  },
  watch: {
    // Отслеживаем изменения edgeColors для принудительного обновления
    edgeColors: {
      handler() {
        this.$forceUpdate();
      },
      deep: true
    },
    // Принудительно обновляем при изменении дефолтной кромки
    edgeDefault: {
      handler() {
        this.$nextTick(() => {
          this.$forceUpdate();
        });
      },
      deep: true
    },
    // Принудительно обновляем при изменении кромок
    edges: {
      handler() {
        this.$nextTick(() => {
          this.$forceUpdate();
        });
      },
      deep: true
    }
  },
  mounted() {
    document.addEventListener("click", this.closePicker);

    // Загружаем цвета если их еще нет
    if (!this.edgeColors || this.edgeColors.length === 0) {
      this.$store.dispatch('data/loadColors');
    }
  },
  beforeDestroy() {
    document.removeEventListener("click", this.closePicker);
  }
}
</script>


<style scoped>
.edges-container {
  background: #f8f9fa;
  border-radius: 6px;
  padding: 10px;
  width: 100%;
}

.edges-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  padding-bottom: 6px;
  border-bottom: 1px solid #dee2e6;
}

.edges-title {
  margin: 0;
  font-size: 0.85rem;
  font-weight: 600;
  color: #495057;
  display: flex;
  align-items: center;
  gap: 6px;
}

.edges-title i {
  color: #2c5aa0;
  font-size: 0.8rem;
}

.edges-help {
  margin-left: 8px;
  color: #6c757d;
  cursor: help;
}

.edges-help i {
  font-size: 0.75rem;
  color: #6c757d !important;
}

.edges-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.edge-item {
  display: flex;
  align-items: center;
  background: white;
  padding: 6px 8px;
  border-radius: 4px;
  border: 1px solid #e9ecef;
  transition: all 0.2s ease;
  gap: 8px;
  min-height: 40px;
}


.edge-item.is-default {
  background: #f0f4ff;
  border-color: #2c5aa0;
  box-shadow: 0 0 0 1px rgba(44, 90, 160, 0.1);
}

.edge-number {
  font-weight: 600;
  color: #495057;
  font-size: 0.8rem;
  min-width: 20px;
  text-align: center;
  flex-shrink: 0;
  margin-top: 2px;
}

.edge-default {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  min-width: 24px;
  flex-shrink: 0;
  margin-top: 2px;
}

.radio-input {
  display: none;
}

.radio-label {
  width: 16px;
  height: 16px;
  border: 2px solid #dee2e6;
  border-radius: 50%;
  cursor: pointer;
  position: relative;
  transition: all 0.2s ease;
  margin: 0;
}

.radio-label:hover {
  border-color: #2c5aa0;
}

.radio-input:checked+.radio-label {
  border-color: #2c5aa0;
  background: #2c5aa0;
}

.radio-input:checked+.radio-label::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 6px;
  height: 6px;
  background: white;
  border-radius: 50%;
}

.edge-content {
  flex: 1;
  min-width: 0;
}

.edge-name {
  font-weight: 500;
  font-size: 0.85rem;
  cursor: default;
  word-wrap: break-word;
  word-break: break-word;
  line-height: 1.3;
}

.edge-actions {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  flex-shrink: 0;
}

.color-picker-container {
  position: relative;
  display: inline-block;
}

.color-box {
  width: 24px;
  height: 24px;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #ccc;
  position: relative;
}

.popover {
  position: absolute;
  top: 22px;
  right: 0;
  z-index: 999999;
  margin-top: 8px;
  border: none;
  background: transparent;
}

.loading-spinner {
  width: 12px;
  height: 12px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-top: 1px solid #fff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

@keyframes spin {
  0% {
    transform: translate(-50%, -50%) rotate(0deg);
  }

  100% {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}


.materials-empty {
  margin-top: 5px;
  text-align: center;
  color: #6c757d;
}

.materials-empty i {
  margin-right: 6px;
}

/* Add Material Button */
.add-material-button {
  border: 2px dashed #2c5aa0;
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.3s ease;
  background: rgba(44, 90, 160, 0.02);
  min-height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.add-material-button:hover {
  background: rgba(44, 90, 160, 0.08);
  border-color: #1e4a8a;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(44, 90, 160, 0.15);
}

.add-button-content {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  color: #2c5aa0;
}

.add-button-content i {
  font-size: 1.5rem;
  color: #2c5aa0;
  margin: 0;
}

.add-button-content span {
  font-size: 0.9rem;
  font-weight: 500;
  color: #2c5aa0;
}

/* Bootstrap button overrides */
.btn-sm {
  padding: 3px 6px;
  font-size: 0.7rem;
}

.btn-primary {
  background-color: #2c5aa0;
  border-color: #2c5aa0;
  color: white;
  padding: 8px 16px;
  font-size: 0.9rem;
  font-weight: 500;
}

.btn-primary:hover {
  background-color: #1e4a8a;
  border-color: #1e4a8a;
}

.btn-outline-danger {
  color: #dc3545;
  border-color: #dc3545;
}

.btn-outline-danger:hover {
  background-color: #dc3545;
  border-color: #dc3545;
  color: white;
}

.btn-outline-primary {
  color: #2c5aa0;
  border-color: #2c5aa0;
}

.btn-outline-primary:hover {
  background-color: #2c5aa0;
  border-color: #2c5aa0;
  color: white;
}
</style>